import React from "react";
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";
import { toast } from "react-toastify";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import FormTopMenu from "../../Components/FormTopMenu";
import { favoriteStatus, editorAllowedLineHeights, editorAllowedFonts, editorAllowedFontSizes, editorAllowedTextColors } from "../../config";
import CommonApi from "../../Core/Api/CommonApi";
import FavoritesApi from "../../Core/Api/FavoritesApi";
// We should register Quill pluging using their own way.
import '../../Core/Quill/blots/ResponsiveVideo';
import { dateToStr, strToDate } from '../../Core/Utils';
import Layout from "../../Layout/Layout";
import "./FavoriteEdit2.scss";

//~ Quill extension.

const icons = Quill.import("ui/icons");
icons["header"] = "H";
// @todo: Better import svg from 'quill/assets/icons/video.svg'.
icons["responsive-video"] = '<svg viewBox="0 0 18 18"><rect class="ql-stroke" height="12" width="12" x="3" y="3"></rect> <rect class="ql-fill" height="12" width="1" x="5" y="3"></rect> <rect class="ql-fill" height="12" width="1" x="12" y="3"></rect> <rect class="ql-fill" height="2" width="8" x="5" y="8"></rect> <rect class="ql-fill" height="1" width="3" x="3" y="5"></rect> <rect class="ql-fill" height="1" width="3" x="3" y="7"></rect> <rect class="ql-fill" height="1" width="3" x="3" y="10"></rect> <rect class="ql-fill" height="1" width="3" x="3" y="12"></rect> <rect class="ql-fill" height="1" width="3" x="12" y="5"></rect> <rect class="ql-fill" height="1" width="3" x="12" y="7"></rect> <rect class="ql-fill" height="1" width="3" x="12" y="10"></rect> <rect class="ql-fill" height="1" width="3" x="12" y="12"></rect> </svg>';

const Delta = Quill.import("delta");
const matcher = (node, delta) => {
  return delta.compose(new Delta().retain(delta.length(), { header: 3 }));
};

// 17px is defaul font.
const allowedFontSizes = editorAllowedFontSizes;

const sizeStyle = Quill.import('attributors/style/size');
sizeStyle.whitelist = allowedFontSizes;
Quill.register(sizeStyle, true);

const allowedFonts = editorAllowedFonts;

const fontClass = Quill.import('attributors/class/font');
fontClass.whitelist = allowedFonts;
Quill.register(fontClass, true);

// Please note the integer data-value-s should be without float point. 
const allowedLineHeights = editorAllowedLineHeights;

const Parchment = Quill.import('parchment');
const lineHeightConfig = {
  scope: Parchment.Scope.INLINE,
  whitelist: allowedLineHeights
};
// const lineHeightClass = new Parchment.Attributor.Class('lineheight', 'ql-line-height', lineHeightConfig);
const lineHeightStyle = new Parchment.Attributor.Style('lineheight', 'line-height', lineHeightConfig);
// Quill.register(lineHeightClass);
Quill.register(lineHeightStyle);

//~ Quill extension.

class FavoriteEdit2 extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      title: '',
      body: '',
      status: favoriteStatus.Draft,
      published_at: new Date(),
      displayPublishConfirmation: false,
      error: ''
    };

    this.id = props.match.params.id ? props.match.params.id : '';

    this.textBox = null;

    this.quill = null;
  }

  setRef = node => {
    if (node == null) {
      return;
    }

    this.quill = node;
  }
  
  componentDidMount = () => {

    this.fetchCountries();

    // If the favorite is new, don't try to load it from the remote source.
    if (!this.id) {
      return;
    }

    this.fetchFavorite(this.id);    
  };

  render = () => {
    const { body, displayPublishConfirmation } = this.state;

    return (
      <Layout bg="light">
        <FormTopMenu items={[
            { action: () => this.props.history.push('/tips'), label: 'BACK' },
            { action: this.togglePublishConfirmation, label: "PUBLISH" }
        ]} />

        <main className="normal-container mb-5 mt-2">
          <ReactQuill
            theme="snow"
            modules={this.modules}
            formats={this.formats}
            placeholder="..."
            value={body}
            onChange={this.handleEditorChange}
            ref={this.setRef}
            className="favorites-editor"
          />
        </main>

        <Modal
          isOpen={displayPublishConfirmation}
          toggle={this.togglePublishConfirmation}
          fade={false}
          centered={true}
        >
          <ModalHeader toggle={this.togglePublishConfirmation}>
            Publish Confirmation
          </ModalHeader>
          <ModalBody>Do you really want to publish the favorite?</ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.publishFavorite}>
              Publish
            </Button>
            &nbsp;
            <Button color="secondary" onClick={this.togglePublishConfirmation}>
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
      </Layout>
    );
  };

  handleEditorChange = value => {
    this.setState({
      body: value
    });
  }

  handleSaveClick = (redirectToNext = false) => {
    const favorite = Object.assign({}, this.state);
    favorite.published_at = dateToStr(favorite.published_at);

    this.updateFavoriteBody(favorite, redirectToNext);
  };

  togglePublishConfirmation = () => {
    this.setState({
      displayPublishConfirmation: !this.state.displayPublishConfirmation
    });
  };

  publishFavorite = () => {
    const {id, body} = this.state;

    FavoritesApi.publishFavorite(id, body)
      .then(data => {
        if (data.data.publishFavorite) {
          const story = data.data.publishFavorite;

          this.setState({
            status: story.status
          });

          this.props.history.push('/favorites');
        } else {
          // @todo: Handle errors better.
          console.warn(data);
          this.reportError("An error occured.");
        }
      })
      .catch(err => {
        // @todo: Handle errors better.
        console.warn(err);
        this.reportError("An error occured.");
      });
  }

  updateFavoriteBody = (favorite, redirectToNext) => {
    FavoritesApi.updateFavoriteBody(favorite)
        .then(data => {
          if (data.data.updateFavoriteBody) {
            const state = data.data.updateFavoriteBody;
            
            this.setState(state);

            this.props.history.push(redirectToNext ? `/favorite/${state.id}/body/` : '/favorites');
          } else {
            // @todo: Handle errors better.
            console.warn(data);
            this.reportError("An error occured.");
          }
        })
        .catch(err => {
          // @todo: Handle errors better.
          console.warn(err);
          this.reportError("An error occured.");
        });
  }

  fetchCountries = () => {
    CommonApi.fetchCountries()
      .then(data => {
        if (data.data.countries && data.data.countries.length > 0) {
          this.setState({
            'allCountries': data.data.countries
          });
        } else {
          // @todo: Handle errors better.
          console.warn(data);
          this.reportError("An error occured.");
        }
      })
      .catch(err => {
        // @todo: Handle errors better.
        console.warn(err);
        this.reportError("An error occured.");
      });
  }

  fetchFavorite = (id) => {
    FavoritesApi.fetchFavorite(id)
    .then(data => {
      if (data.data.favorites && data.data.favorites.length > 0) {
        const favorite = data.data.favorites[0];

        favorite.categories = favorite.categories.map(item => {
          return item.id;
        });

        if (favorite.country_code === null) {
          favorite.country_code = '';
        }

        if (favorite.published_at) {
          favorite.published_at = strToDate(favorite.published_at);
        }

        this.setState(favorite);
      } else {
        // @todo: Handle errors better.
        console.warn(data);
        this.reportError("An error occured.");
      }
    })
    .catch(err => {
      // @todo: Handle errors better.
      console.warn(err);
      this.reportError("An error occured.");
    });
  }

  reportError = message => {
    toast.error(message)
  };

  modules = {
    toolbar: {
      container: [
        { 'color': editorAllowedTextColors },
        { 'font': allowedFonts },
        { 'size': allowedFontSizes },
        { 'lineheight': allowedLineHeights },
        { header: 3 },
        'bold',
        'italic',
        { list: 'ordered' },
        { list: 'bullet' },
        'link',
        'blockquote',
        'image',
        'responsive-video'
      ],
      handlers: {
        "responsive-video": function(value) {
          if (value) {
            let url = prompt("Please enter video url");
            if (url != null) {
              const range = this.quill.getSelection(true);
              // this.quill.insertText(range.index, "\n", Quill.sources.USER);
              this.quill.insertEmbed(range.index, "responsive-video", url, Quill.sources.USER);
              this.quill.setSelection(range.index + 1, Quill.sources.SILENT);
            }
          }
        },
        'image': this.imageHandler.bind(null, this)
      }
    },
    clipboard: {
      matchVisual: false, // https://quilljs.com/docs/modules/clipboard/#matchvisual
      matchers: [["h1", matcher], ["h2", matcher]]
    }
  };

  formats = [
    'color',
    'font',
    'size',
    'lineheight',
    'header',
    'bold',
    'italic',
    'link',
    'blockquote',
    'list',
    'image',
    'responsive-video'
  ];

  imageHandler(component) {

    const quill = component.quill;
    const quillEditor = quill.getEditor();
    const favoriteId = component.id;

    let fileInput = quillEditor.container.querySelector('input.ql-image[type=file]');
    if (fileInput == null) {
        fileInput = document.createElement('input');
        fileInput.setAttribute('type', 'file');
        fileInput.setAttribute('accept', 'image/*');
        fileInput.classList.add('ql-image');
        fileInput.addEventListener('change', () => {
            const files = fileInput.files;
            const range =  quillEditor.getSelection(true);
            
            if (!files || !files.length) {
                toast.warn('No files selected');
                return;
            }

            quillEditor.enable(false);

            FavoritesApi
              .uploadFavoriteContentImage(favoriteId, files[0])
              .then(data => {
                if (data.data.uploadFavoriteContentImage && data.data.uploadFavoriteContentImage.id) {
                  const favoriteImage = data.data.uploadFavoriteContentImage;

                  quillEditor.enable(true);
                  quillEditor.insertEmbed(range.index, 'image', favoriteImage.url);
                  quillEditor.insertText(range.index + 1, ' ', Quill.sources.SILENT);
                  quillEditor.setSelection(range.index + 2, Quill.sources.SILENT);
                  fileInput.value = '';
                } else {
                  console.warn(data);
                  component.reportError("An error occured.");
                  quillEditor.enable(true);
                }
              })
              .catch(err => {
                console.warn(err);
                component.reportError("An error occured.");
                quillEditor.enable(true);
              });
        });
        quillEditor.container.appendChild(fileInput);
    }
    fileInput.click();
  }
}

export default FavoriteEdit2;
